import { Card, Divider, Grid, List, ListItem, ListItemAvatar, ListItemText } from '@material-ui/core';
import { AccountBoxSharp, AccountCircle, Email, Fingerprint, PersonAdd, PhoneAndroid } from '@material-ui/icons';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserRequest } from '../../store/user/user.actions';
import { getCurrentUser } from '../../store/user/user.selector';
import TitleBar from '../base/TitleBar';
import ChangePassword from './changePassword';
import Loader from '../base/loader';

export default function ProfileContainer() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchUserRequest())
    }, [])

    const { currentUser, isLoading } = useSelector((state) => {
        return {
            currentUser: getCurrentUser(state) || {},
            isLoading: state.UserReducer.isLoading
        }
    }, []);

    return (
        <div className="profile-page m-2">
            {
                isLoading && <Loader />
            }
            <section className="profile-intro">
                <div>
                    <span className="profile-eyebrow">ACCOUNT CENTER</span>
                    <h1>Profile & security</h1>
                    <p>Manage your account identity and keep your access credentials up to date.</p>
                </div>
                <div className="profile-badge"><AccountCircle /><span>Active account</span></div>
            </section>
            <Grid container spacing={2} className='profile-grid'>
                <Grid item md={7} lg={7} sm={12} xs={12}>
                    <Card elevation={0} className="profile-panel identity-panel">
                        <div className="profile-panel-heading">
                            <div className="profile-avatar"><AccountCircle /></div>
                            <div><span className="profile-panel-kicker">PERSONAL DETAILS</span><h2>Account identity</h2><p>Information associated with this administrator account.</p></div>
                        </div>
                    <List className="profile-details">
                        <ListItem>
                            <ListItemAvatar>
                                <AccountBoxSharp />
                            </ListItemAvatar>
                            <ListItemText primary={currentUser.firstName + " " + currentUser.lastName} secondary="Name" />
                        </ListItem>
                        <Divider />

                        <ListItem>
                            <ListItemAvatar>
                                <Fingerprint />
                            </ListItemAvatar>
                            <ListItemText primary={currentUser.userId} secondary="User #" />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <ListItemAvatar>
                                <Email />
                            </ListItemAvatar>
                            <ListItemText primary={currentUser.email} secondary="Email" />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <ListItemAvatar>
                                <PhoneAndroid />
                            </ListItemAvatar>
                            <ListItemText primary={currentUser.country + " " + currentUser.mobileNumber} secondary="Mobile Number" />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <ListItemAvatar>
                                <PersonAdd />
                            </ListItemAvatar>
                            <ListItemText primary={currentUser.role} secondary="Role" />
                        </ListItem>
                    </List>
                    </Card>
                </Grid>
                <Grid item md={5} lg={5} sm={12} xs={12}>
                    <Card elevation={0} className="profile-panel security-panel">
                        <div className="profile-panel-heading">
                            <div className="security-icon"><Fingerprint /></div>
                            <div><span className="profile-panel-kicker">ACCESS CONTROL</span><h2>Change password</h2><p>Use a strong password to protect your workspace.</p></div>
                        </div>
                        <ChangePassword canShow={true} />
                    </Card>
                </Grid>
            </Grid>
        </div >
    );
}

